/*
 * (14) O link permanente da mensagem: `/chat/c/ID?message=MSG`
 * (ou o do fio, `/chat/c/ID/t/FIO?message=MSG`). Ao abrir, a página do chat
 * carrega a conversa até a mensagem (o `revealMessage` do ramon/chat), rola
 * até ela e a destaca. É o endereço do "Copiar link" e dos avisos do sino.
 */
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import { chatState, component, feature, ramonModule } from './flags';

/** O endereço absoluto de uma mensagem. */
export function messageUrl(message) {
  const channelId = Number(message.channelId?.() ?? message.channelId);
  const threadId = message.threadId?.();
  const params = {
    id: channelId,
    message: message.id?.() ?? message.id
  };
  const path = threadId ? app.route('chat.thread', {
    ...params,
    threadId
  }) : app.route('chat.channel', params);
  return new URL(path, window.location.origin).href;
}

/** O caminho (relativo) de uma mensagem a partir dos números, para os avisos do sino. */
export function messagePath(channelId, messageId, threadId) {
  return threadId ? app.route('chat.thread', {
    id: channelId,
    threadId,
    message: messageId
  }) : app.route('chat.channel', {
    id: channelId,
    message: messageId
  });
}

/** Mensagens já levadas à tela nesta visita (o `view` roda a cada redesenho). */
const handled = new Set();
async function reveal(channelId, messageId, inThread) {
  const jump = ramonModule('forum/utils/jumpToMessage');
  if (!jump?.jumpToMessage) return;

  // O fio desenha a própria lista; espera ela existir e tenta de novo.
  for (let attempt = 0; attempt < 24; attempt++) {
    const scroller = document.querySelector(inThread ? '.ChatThreadPanel-stream' : '.ChatChannel-stream');
    if (scroller) {
      if (jump.jumpToMessage(messageId, scroller)) return;
      if (!inThread && jump.revealAndJump) {
        await jump.revealAndJump(chatState(), channelId, messageId, scroller);
        return;
      }
    }
    await new Promise(resolve => setTimeout(resolve, 250));
  }
}
export default function installPermalink() {
  extend(component('ChatPage'), 'view', function () {
    if (!feature('permalink')) return;
    const messageId = Number(m.route.param('message'));
    const channelId = Number(m.route.param('id'));
    if (!messageId || !channelId) return;
    const key = `${channelId}:${messageId}`;
    const state = chatState();
    if (handled.has(key) || !state || state.activeChannelId !== channelId || !state.stream(channelId)?.loadedInitial) return;
    handled.add(key);

    // Depois deste desenho: a lista precisa estar na tela para rolar.
    setTimeout(() => reveal(channelId, messageId, !!m.route.param('threadId')).then(() => m.redraw()), 0);
  });
}
flarum.reg.add('ramon-canela', 'forum/thirdparty/ramonChat/features/permalink', installPermalink);